module.exports = __webpack_public_path__ + "static/media/henry.1df395bf.png";